export default __webpack_public_path__ + "static/media/add.37ba673f.png";